import * as PIXI from "pixi.js";
import Main from "../Main";
import ButtonLayer from "../layers/ButtonLayer";
import { BarBGBounds } from "../types/Interface";
import { EnumEventBus, EventBus } from "../managers/EventBus";
import TextureManager from "../managers/TextureManager";
import PrizePopupAnimation from "../animations/PrizePopupAnimation";

const TOTAL_WON_PATH = "./images/scene/total_won.png";


export default class TotalWon extends PIXI.Container {
  Main = Main.getInstance();
  ButtonLayer = ButtonLayer.getInstance();
  EventBus = EventBus;
  totalWon: number = 0;
  Bounds: BarBGBounds;
  totalWonText: PIXI.Text;
  PrizePopup: PIXI.Container;

  constructor(Bounds: BarBGBounds) {
    super();
    this.Bounds = Bounds
    this.x = Bounds.x;
    this.y = Bounds.y;
    this.addBg();
    this.addtotalWonText();
    this.addTotalPrizePopup();
    this.addToLayer();

    this.EventBus.on(EnumEventBus.setTotalWon, (amount: number) => {
      this.setTotalWon(Number(amount.toFixed(2)));
      this.setTotalWonText();
    })
  }
  addBg() {
    const texture = TextureManager.getTexture(TOTAL_WON_PATH);
    const bg = new PIXI.Sprite(texture);
    bg.width = this.Bounds.width;
    bg.height = this.Bounds.height;
    bg.anchor.set(.5);
    this.addChild(bg);
  }
  addtotalWonText() {
    const style = { fill: 0xFFFFFF, fontSize: this.Bounds.fontSize }
    this.totalWonText = new PIXI.Text({ text: "", style });
    this.totalWonText.x = 0;
    this.totalWonText.y = 17;
    this.totalWonText.style.fontWeight = "700"
    this.totalWonText.anchor.set(.5);
    this.addChild(this.totalWonText);
  }
  showPrizePopup(amount: number, cb: () => void) {
    this.PrizePopup.visible = true;
    (this.PrizePopup.children[1] as PIXI.Text).text = `$${amount}`;
    new PrizePopupAnimation(this.PrizePopup, 305 * .5, () => {
      setTimeout(() => {
        this.PrizePopup.visible = false;
        this.PrizePopup.children[0].width = 305 * .3;
        this.PrizePopup.children[0].height = 305 * .3;
        setTimeout(() => {
          cb();
        }, 1000);
      }, 1500);
    })
  }
  addTotalPrizePopup() {
    const dim = this.Main.getDim();
    const texture = TextureManager.getTexture("./images/scene/one-fire-box.png");
    const bg = new PIXI.Sprite(texture);
    bg.anchor.set(.5);
    bg.width = 305 * .2;
    bg.height = 305 * .2;
    bg.x = dim.width / 2;
    bg.y = dim.height / 2;

    const prize = new PIXI.Text();
    prize.style.fontWeight = "800";
    prize.anchor.set(.5);
    prize.x = dim.width / 2;
    prize.y = dim.height / 2;

    this.PrizePopup = new PIXI.Container();
    this.PrizePopup.visible = false;
    this.PrizePopup.addChild(bg, prize);
    this.ButtonLayer.addChild(this.PrizePopup);
  }
  setTotalWon(amount: number) {
    if (amount == 0) {
      return
    }
    this.showPrizePopup(amount, () => {
      this.totalWon += amount;

    })
  }
  setTotalWonText() {
    this.totalWonText.text = `$${this.totalWon.toFixed(2)}`;
  }
  addToLayer() {
    this.ButtonLayer.addChild(this);
  }
}